import { render, staticRenderFns } from "./rulesSetting.vue?vue&type=template&id=730def46&"
import script from "./rulesSetting.vue?vue&type=script&lang=ts&"
export * from "./rulesSetting.vue?vue&type=script&lang=ts&"
import style0 from "./rulesSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports